import React, { useState, useEffect } from 'react';
import { Col, Container, Row } from 'reactstrap';
import { Link } from "react-router-dom";
import { animateScroll as scroll } from 'react-scroll';
import * as Icon from 'react-feather';
import { getPayloadMedia } from "../services/payloadService";

export default function Footer({ configuracion }) {
    const [arrow, setArrow] = useState(false);

    const handleScroll = () => {
        if (
            document.body.scrollTop >= 500 ||
            document.documentElement.scrollTop >= 500
        ) {
            setArrow(true);
        } else {
            setArrow(false);
        }
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    // Formatear número de teléfono para WhatsApp (remover espacios, guiones, paréntesis)
    const getWhatsAppNumber = (phone) => {
        if (!phone) return '';
        return phone.replace(/[^\d+]/g, '');
    };

    const whatsappNumber = getWhatsAppNumber(configuracion?.telefono);
    const logoPrincipal = getPayloadMedia(configuracion?.logoPrincipalWhite?.url);
    const logoSecundario = getPayloadMedia(configuracion?.logoSecundarioWhite?.url);
    const whatsappUrl = whatsappNumber ? `https://wa.me/${whatsappNumber}` : '#';

    const scrollToTop = () => {
        scroll.scrollToTop({
            duration: 500,
            smooth: 'easeInOutQuart'
        });
    };

    return (
        <>
            {/* Back to top */}
            <button 
                onClick={scrollToTop}
                style={{ display: arrow === true ? 'flex' : 'none', alignItems: 'center', justifyContent: 'center' }} 
                id="back-to-top" 
                className="back-to-top rounded-pill fs-5"
            >
                <Icon.ArrowUp className="fea icon-sm icons align-middle" />
            </button>
            {/* Back to top  */}

            {/* Footer Start */}
            <footer className="bg-footer" style={{ backgroundColor: 'var(--color-primary) !important' }}>
                <Container>
                    <Row>
                        <div className="col-12">
                            <div className="footer-py-60">
                                <Row>
                                    {/* Logo & Description */}
                                    <div className="col-lg-3 col-12 mb-lg-0 mb-md-4 pb-lg-0 pb-md-2">
                                        <Link to="/" className="logo-footer">
                                            <img
                                                src={logoPrincipal}
                                                height="40"
                                                alt={configuracion?.nombreSitio || ''}
                                            />
                                            <img
                                                src={logoSecundario}
                                                height="24"
                                                alt={configuracion?.nombreSitio || ''}
                                            />
                                        </Link>
                                        <p className="mt-4 mb-0">
                                            {configuracion?.nombreSitio
                                                ? `${configuracion.nombreSitio} - ${configuracion.slogan}`
                                                : ''}
                                        </p>

                                        {configuracion?.horarioAtencion && (
                                            <div className="pt-3 d-flex align-items-center">
                                                <i className="uil uil-clock text-success me-2 fs-1"></i>
                                                <div className="content">
                                                    <p className="mb-1 text-foot">Horario:</p>
                                                    <span className="text-light">{configuracion.horarioAtencion}</span>
                                                </div>
                                            </div>
                                        )}
                                    </div>

                                    {/* Our Services */}
                                    {configuracion?.serviciosFooter && configuracion.serviciosFooter.length > 0 && (
                                        <div className="col-lg-3 col-md-4 col-12 mt-4 mt-sm-0 pt-2 pt-sm-0">
                                            <h5 className="footer-head">Nuestros Servicios</h5>
                                            <ul className="list-unstyled footer-list mt-4">
                                                {configuracion.serviciosFooter.map((servicio, index) => (
                                                    <li key={index}>
                                                        <Link to={servicio.url || "#"} className="text-foot">
                                                            <i className="uil uil-angle-right-b me-1"></i> {servicio.nombre}
                                                        </Link>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    )}

                                    {/* Get In Touch */}
                                    <div className="col-lg-3 col-md-4 col-12 mt-4 mt-sm-0 pt-2 pt-sm-0">
                                        <h5 className="footer-head">Contáctanos</h5>

                                        {configuracion?.direccion && (
                                            <p className="mt-4">{configuracion.direccion}</p>
                                        )}

                                        <ul className="list-unstyled footer-list mt-3">
                                            {configuracion?.telefono && (
                                                <li>Teléfono: <a href={`tel:${configuracion.telefono}`} className="text-light">{configuracion.telefono}</a></li>
                                            )}
                                            {configuracion?.email && (
                                                <li>Email: <a href={`mailto:${configuracion.email}`} className="text-light">{configuracion.email}</a></li>
                                            )}
                                        </ul>
                                    </div>

                                    {/* WhatsApp CTA */}
                                    <div className="col-lg-3 col-md-4 col-12 mt-4 mt-sm-0 pt-2 pt-sm-0">
                                        <h5 className="footer-head">
                                            {configuracion?.tituloAyuda}
                                        </h5>
                                        <p className="mt-4">
                                            {configuracion?.textoAyuda}
                                        </p>

                                        <div className="mt-4">
                                            <a
                                                href={whatsappUrl}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="btn btn-success-outline d-flex align-items-center justify-content-center"
                                            >
                                                <i className="uil uil-whatsapp me-2 fs-5"></i>
                                                {configuracion?.textoBotonWhatsApp}
                                            </a>
                                        </div>
                                    </div>
                                </Row>
                            </div>
                        </div>
                    </Row>
                </Container>

                {/* Footer Bottom Bar */}
                <div className="footer-py-30 footer-bar">
                    <div className="container text-center">
                        <Row className="align-items-center justify-content-center">
                            <Col sm={8}>
                                <div className="text-sm-start">
                                    <p className="mb-0">
                                        {configuracion?.textoFooter ||
                                            `© ${new Date().getFullYear()} ${configuracion?.nombreSitio}`}
                                    </p>
                                </div>
                            </Col>

                            <div className="col-sm-4 mt-4 mt-sm-0">
                                <ul className="list-unstyled social-icon text-sm-end foot-social-icon mb-0">
                                    {configuracion?.redesSociales?.facebook && (
                                        <li className="list-inline-item ms-1">
                                            <a href={configuracion.redesSociales.facebook} className="rounded" target="_blank" rel="noopener noreferrer">
                                                <i className="uil uil-facebook-f align-middle" title="Facebook"></i>
                                            </a>
                                        </li>
                                    )}
                                    {configuracion?.redesSociales?.instagram && (
                                        <li className="list-inline-item ms-1">
                                            <a href={configuracion.redesSociales.instagram} className="rounded" target="_blank" rel="noopener noreferrer">
                                                <i className="uil uil-instagram align-middle" title="Instagram"></i>
                                            </a>
                                        </li>
                                    )}
                                    {configuracion?.redesSociales?.twitter && (
                                        <li className="list-inline-item ms-1">
                                            <a href={configuracion.redesSociales.twitter} className="rounded" target="_blank" rel="noopener noreferrer">
                                                <i className="uil uil-twitter align-middle" title="Twitter"></i>
                                            </a>
                                        </li>
                                    )}
                                    {configuracion?.redesSociales?.linkedin && (
                                        <li className="list-inline-item ms-1">
                                            <a href={configuracion.redesSociales.linkedin} className="rounded" target="_blank" rel="noopener noreferrer">
                                                <i className="uil uil-linkedin align-middle" title="LinkedIn"></i>
                                            </a>
                                        </li>
                                    )}
                                </ul>
                            </div>
                        </Row>
                    </div>
                </div>
            </footer>
            {/* Footer End  */}
        </>
    );
}
